import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[agrFileUploadPreviewTemplate]' })
export class FileUploadPreviewTemplateDirective<T> {
  constructor(public templateRef: TemplateRef<T>) {}
}
